<template>
	<div class="container wc-container wc-container-720">
			<div class="widgets">
				<!-- widgets-list -->
				<ul class="widgets-list" v-if="widgets.length">
					<li v-for="widget in widgets" @click="openWidget(widget['_id'])">{{ widget.title }}</li>
				</ul>

				<Button type="primary" @click="changeWidgetModalVisibility(true)">Add New</Button>

				<Modal
					:value="widgetModalShow"
					title="Add new widget"
					@on-ok="saveWidget"
					@on-cancel="changeWidgetModalVisibility(false)">

					<!-- widget -->
					<widget :widget-data="widgetData" :types="widgetTypes" />

					<div class="widget-footer" slot="footer">
						<div class="widget-actions">
							<Button type="info" @click="saveWidget" :disabled="isSaveEnabled">Save</Button>
			    		<Button type="info" @click="removeWidget" v-if="widgetData['_id']">Delete</Button>
			    		<Button type="error" @click="changeWidgetModalVisibility(false)">Close</Button>
						</div>
					</div>
				</Modal>
			</div>
	</div>
</template>

<script>
	import {
		mapGetters,
	  mapActions
	} from 'vuex'

	import Widget from './Widget.vue'

	export default {
		data () {
			return {
				widgetModalShow: false,
				widgetDataDefault: {
    			webcastId: this.$store.state.webcast.copy._id,
    	  	title: '',
    	  	type: '',
    	  	iframeUrl: '',
    	  	html: ''
    	  },
    	  widgetData: {},
    	  widgetTypes: [
    	  	'HTML',
    	  	'Iframe',
    	  	'Q&A',
          'Speakers',
          'Downloads'
    	  ]
			}
		},

		computed: {
			...mapGetters('webcast', {
				webcast: 'getCopy'
			}),
			...mapGetters('widgets', {
				findWidgetsInStore: 'find'
			}),

			widgets () {
				return this.findWidgetsInStore().data
			},

			isSaveEnabled () {
  			return !Boolean(this.widgetData.title && this.widgetData.type)
  		},

  		isWidgetExists () {
  			let widgetDataId = this.widgetData['_id']

  			return Boolean(this.widgetData && widgetDataId)
  		}
		},

		methods: {
			...mapActions('widgets', {
  			findWidgetsAction: 'find',
      	updateWidgetAction: 'update',
      	createWidgetAction: 'create',
      	removeWidgetAction: 'remove'
    	}),

    	setDefaultWidgetData () {
    		this.widgetData = _.cloneDeep(this.widgetDataDefault)
    	},

			changeWidgetModalVisibility (isShow) {
				this.widgetModalShow = isShow

				if (!isShow) {
					this.setDefaultWidgetData()
				}
			},

			openWidget (id) {
				this.widgetData = _.cloneDeep(this.getWidgetById(id))
				this.changeWidgetModalVisibility(true)
			},

			getWidgetById (id) {
				return (this.widgets && this.widgets.length) ? this.widgets.find(w => w['_id'] === id) : undefined
			},

			saveWidget () {
    		// check if we have an id
    		if (this.isWidgetExists) {
    			// then we will update the existing widgetData
    			this.updateWidgetAction([this.widgetData['_id'], this.widgetData])
    		} else {
    			// else create a new widget
    			this.createWidgetAction(this.widgetData)
    		}

    		// close the widget modal
    		this.changeWidgetModalVisibility(false)
    	},

    	removeWidget () {
    		if (this.widgetData && this.widgetData['_id']) {
    			this.removeWidgetAction(this.widgetData['_id'])

    			// close the widget modal
    			this.changeWidgetModalVisibility(false)
    		}
    	}
		},

		created () {
			this.findWidgetsAction({query: {
				webcastId: this.webcast._id
			}})
			this.setDefaultWidgetData()
		},

		components: {
			Widget
		}
	}
</script>

<style lang="scss" scoped>
	.widgets {
		padding-top: 20px;
		&-list {
			list-style: none;
			margin-bottom: 30px;
			> li {
				padding: 15px 12px;
				cursor: pointer;
				font-size: 18px;
				&:not(:last-of-type) {
					border-bottom: 0.5px solid #e9eaec;
				}
			}
		}
	}

	.widget {
		&-actions {
			.ivu-btn {
				border-color: #2B3143;
				background-color: #2B3143;
				box-shadow: none;
			}
		}
	}
</style>
